const faqItems = [
  {
    q: '麻花影院真的完全免费吗？',
    a: '是的，麻花影院免费观看平台所有内容均免费提供，无需注册、无需付费即可在线播放电影、电视剧和综艺节目。我们通过合理的运营模式维持平台运行，确保用户享受永久免费的观影体验。',
  },
  {
    q: '影片画质如何？会有卡顿吗？',
    a: '麻花影院全站提供高清画质片源，多数影片支持1080P清晰度。平台采用智能CDN加速分发技术，观影流畅不卡顿。如遇网络波动，建议切换清晰度或稍等缓冲，一般几秒即可恢复流畅播放。',
  },
  {
    q: '新片更新速度快吗？',
    a: '很快！麻花影院片源团队每日不间断更新，院线新片通常在首映后数日内即可上线，热播剧集当日同步更新。关注本站「最新更新」栏目可第一时间获取上架通知，追剧再也不用等。',
  },
  {
    q: '需要下载APP或安装插件吗？',
    a: '完全不需要。麻花影院免费观看支持网页端直接播放，手机、平板、电脑均可访问，无需下载任何APP或安装播放插件。当然我们也提供APP版本（见「手机观影」模块），满足不同习惯用户的观影需求。',
  },
  {
    q: '支持哪些设备观看？',
    a: '麻花影院兼容所有主流设备：Windows/Mac 电脑浏览器、iPhone/Android 手机浏览器、iPad/安卓平板均可流畅访问。页面采用响应式设计，自动适配不同屏幕尺寸，随时随地随心观看。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            常见问答
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            关于麻花影院免费观看，你想知道的都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3 md:space-y-4">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
              style={{ animationDelay: `${idx * 80}ms` }}
            >
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2.5 flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 text-xs font-bold mt-0.5">
                    Q
                  </span>
                  {item.q}
                </h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed pl-9">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}